export const CURRENCY_INPUT_ERRORS = {
  HAS_NEGATIVE_ZERO: 'currencyInput.hasNegativeZero',
  MAX_VALUE: 'currencyInput.maxValue',
  MIN_VALUE: 'currencyInput.minValue',
  REQUIRED: 'currencyInput.required',
};
